module.exports = function(el, threshold = 0) {
  if (el == null) {
    return false;
  }

  const rect = el.getBoundingClientRect();

  return rect.top - window.innerHeight - threshold < 0;
};
